import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';

import { NavLink as RouteNavLink, Redirect } from "react-router-dom";
// import {connect} from 'react-redux'
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Collapse,
    NavItem,
    NavLink
} from "shards-react";


export const DropdownUserMenu = (props, context) => {
   
    const { user } = useSelector(state => state.user);
    
    const [visible, setVisible] = useState(false);
    const [logoutState, setLogoutState] = useState(false);

    const handleMenu = () => {
        setVisible (!visible);
    }

    const handleLogout = () => {
        setLogoutState(true);
    }


    if (logoutState) {
        // Redirecting to functional componet to centralize user logout action.
        return <Redirect to='/logout' />
    }

    
    return (
        <NavItem tag={Dropdown} caret toggle={ handleMenu }>

              <DropdownToggle caret tag={NavLink} className="text-nowrap px-3 cursor-pointer">
                <img
                  className="user-avatar rounded-circle mr-2"
                  src={user.avatar_picture}
                  alt="User Avatar"
                />{" "}
                <span className="d-none d-md-inline-block">{user.given_name}</span>
              </DropdownToggle>

              <Collapse tag={DropdownMenu} right small open={visible} onMouseLeave={()=>setVisible(false)} >

                <DropdownItem tag={(props) => <RouteNavLink {...props} />} to="/settings/user-profile">
                  <i className="material-icons" >&#xE7FD;</i> <span>{context.t('Profile')}</span>
                </DropdownItem>

                <DropdownItem tag={(props) => <RouteNavLink {...props} />} to="/settings/user-settings">
                    <i className="material-icons">&#xE8B8;</i> {context.t('Settings')}
                </DropdownItem>
                
                <DropdownItem divider />
                
                <DropdownItem onClick={ handleLogout } className="text-danger"> 
                  <i className="material-icons text-danger">&#xE879;</i> {context.t('Logout')}
                </DropdownItem>

              </Collapse>
            </NavItem>
    );
};


DropdownUserMenu.contextTypes = {
    t: PropTypes.func.isRequired
}

export default DropdownUserMenu;